// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"03bab843","626":"b9816b36","651":"6525d04c"}[chunkId] + ".chunk.js";
};